import {
  $getSelection,
  $isRangeSelection,
  $createParagraphNode,
  LexicalEditor,
} from "lexical";
import { $wrapNodes } from "@lexical/selection";
import {
  INSERT_ORDERED_LIST_COMMAND,
  INSERT_UNORDERED_LIST_COMMAND,
  REMOVE_LIST_COMMAND,
} from "@lexical/list";
import { $createHeadingNode, $createQuoteNode } from "@lexical/rich-text";
import AscDropdown from "../../../../AscDropdown/AscDropdown";
import { BlockType, BlockTypeToBlockName } from "../../../config/constants";
import styles from "./BlockOptionsDropdownList.module.scss";
interface BlockOptionsDropdownListProps {
  editor: LexicalEditor;
  blockType: BlockType;
  disabled?: boolean;
}

export function BlockOptionsDropdownList({
  editor,
  blockType,
  disabled = false,
}: BlockOptionsDropdownListProps) {
  const formatParagraph = () => {
    if (blockType !== "paragraph") {
      editor.update(() => {
        const selection = $getSelection();

        if ($isRangeSelection(selection)) {
          $wrapNodes(selection, () => $createParagraphNode());
        }
      });
    }
  };

  const formatLargeHeading = () => {
    if (blockType !== "h1") {
      editor.update(() => {
        const selection = $getSelection();

        if ($isRangeSelection(selection)) {
          $wrapNodes(selection, () => $createHeadingNode("h1"));
        }
      });
    }
  };

  const formatSmallHeading = () => {
    if (blockType !== "h2") {
      editor.update(() => {
        const selection = $getSelection();

        if ($isRangeSelection(selection)) {
          $wrapNodes(selection, () => $createHeadingNode("h2"));
        }
      });
    }
  };

  const formatBulletList = () => {
    if (blockType !== "ul") {
      editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined);
    } else {
      if (editor._rootElement) {
        editor._rootElement.dataset.fontSize = "";
      }
      editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
    }
  };

  const formatNumberedList = () => {
    if (blockType !== "ol") {
      editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, undefined);
    } else {
      editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
    }
  };

  const formatQuote = () => {
    if (blockType !== "quote") {
      editor.update(() => {
        const selection = $getSelection();

        if ($isRangeSelection(selection)) {
          $wrapNodes(selection, () => $createQuoteNode());
        }
      });
    }
  };

  return (
    <AscDropdown
      disabled={disabled}
      titleContainerClassName={styles["title"]}
      title={BlockTypeToBlockName[blockType]}
      variant="secondary"
    >
      <AscDropdown.Option
        active={blockType === "paragraph"}
        onClick={formatParagraph}
      >
        Normal
      </AscDropdown.Option>
      <AscDropdown.Option
        active={blockType === "h1"}
        onClick={formatLargeHeading}
      >
        Large Heading
      </AscDropdown.Option>
      <AscDropdown.Option
        active={blockType === "h2"}
        onClick={formatSmallHeading}
      >
        Small Heading
      </AscDropdown.Option>
      <AscDropdown.Option
        active={blockType === "ul"}
        onClick={formatBulletList}
      >
        Bullet List
      </AscDropdown.Option>
      <AscDropdown.Option
        active={blockType === "ol"}
        onClick={formatNumberedList}
      >
        Numbered List
      </AscDropdown.Option>
      <AscDropdown.Option active={blockType === "quote"} onClick={formatQuote}>
        Quote
      </AscDropdown.Option>
    </AscDropdown>
  );
}
